import { render, staticRenderFns } from "./error_box.vue?vue&type=template&id=3527bcef"
import script from "./error_box.vue?vue&type=script&lang=js"
export * from "./error_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "error_box.vue"
export default component.exports